import { Button } from "@components/button";
import { EllipsisText } from "@components/ellipsis-text";
import { Modal } from "@components/modal";
import { RowTable } from "@components/row-table";
import { StatusBlock, StatusBlockType } from "@components/status-block";
import { Config, DoubleText } from "@components/table";
import { MerchantOrderPayout } from "@features/merchantPayout/api";
import { formatDate, formatTime } from "@helpers/date";
import { formatRubles, formatUsdt } from "@helpers/format";
import { useBoolState } from "@hooks/use-bool-state";
import { PayoutAppealModal } from "./appealModal";

type Props = {
  isOpen: boolean;
  hide: () => void;
  data: MerchantOrderPayout;
};

const modalConfig: Config<MerchantOrderPayout> = [
  {
    label: "Номер заявки",
    source: "invid",
    renderComponent: (data) => <EllipsisText text={data} copy />,
  },
  {
    label: "Касса",
    source: "invid",
    renderComponent: () => "no data",
  },
  {
    label: "Дата и время создания",
    source: "created_at_unix",
    renderComponent: (data) => (
      <DoubleText
        text={formatTime(new Date(data * 1000))}
        subText={formatDate(new Date(data * 1000))}
      />
    ),
  },
  {
    label: "Дата и время закрытия",
    source: "closed_time_unix",
    renderComponent: (data) => (
      <DoubleText
        text={formatTime(new Date(data * 1000))}
        subText={formatDate(new Date(data * 1000))}
      />
    ),
  },
  {
    label: "Статус заявки",
    source: "status",
    renderComponent: (data) => {
      let text = "";
      let status: StatusBlockType = StatusBlockType.Error;
      switch (data) {
        case "created":
          text = "Создано";
          status = StatusBlockType.Success;
          break;
        case "completed":
          text = "Успешно";
          status = StatusBlockType.Success;
          break;
        case "dispute_open":
          text = "Открыт спор";
          status = StatusBlockType.Orange;
          break;
        case "processing":
        case "pending":
        case "assigned_to_trader":
          text = "Ожидание";
          status = StatusBlockType.Warning;
          break;
        case "under_review_by_support":
          text = "На рассмотрении";
          status = StatusBlockType.Warning;
          break;
        case "failed":
        case "canceled":
          text = "Отклонена";
          status = StatusBlockType.Error;
          break;
      }
      return <StatusBlock text={text} type={status} />;
    },
  },
  { label: "Способ", source: "method" },
  { label: "Реквизиты", source: "requisite" },
  { label: "Банк", source: "bank" },
  { label: "Курс", source: "exchange_rate" },
  {
    label: "Сумма ",
    source: "sum",
    renderComponent: (data, item) => (
      <DoubleText
        text={formatRubles(data)}
        subText={formatUsdt(item.sum_usdt)}
      />
    ),
  },
  {
    label: "Сумма к списанию",
    source: "merchant_spend_rub",
    renderComponent: (data, item) => (
      <DoubleText
        text={formatRubles(data)}
        subText={formatUsdt(item.merchant_spend_usdt)}
      />
    ),
  },
];

export const MerchantWithdrawalModal = ({ isOpen, hide, data }: Props) => {
  const isCompleted = data.status == "completed";
  const isDisputeOpen = data.status == "dispute_open";
  const [isOpenAppeal, open, close] = useBoolState(false);

  const createAppeal = () => {
    hide();
    open();
  };
  return (
    <>
      <Modal isOpen={isOpen} onClose={hide} title={`Заявка № ${data.invid}`}>
        <RowTable config={modalConfig} data={data} />
        {(isCompleted || isDisputeOpen) && (
          <Button onClick={createAppeal}>{isCompleted ? "Создать апелляцию" : "Посмотреть апелляцию"}</Button>
        )}
      </Modal>
      <PayoutAppealModal
        isModalOpen={isOpenAppeal}
        hideModal={close}
        data={data}
        isView={!isCompleted}
      />
    </>
  );
};
